/**
 * Centralized environment configuration.
 * Reads from runtime browser config first, then falls back to build-time env.
 * All environment-dependent values should be accessed through this module.
 */

type AppRuntimeConfig = {
  monerisIframeUrl?: string;
  monerisOrigin?: string;
  paymentApiUrl?: string;
  subscriptionKey?: string;
};

const runtimeConfig: AppRuntimeConfig =
  typeof window !== 'undefined' ? window.__APP_CONFIG__ || {} : {};

const environment = Object.freeze({
  // Runtime config lets the same built image serve multiple environments.
  monerisIframeUrl:
    runtimeConfig.monerisIframeUrl ||
    import.meta.env.MONERIS_IFRAME_URL ||
    import.meta.env.VITE_MONERIS_IFRAME_URL ||
    'https://esqa.moneris.com/HPPtoken/index.php',
  monerisOrigin:
    runtimeConfig.monerisOrigin ||
    import.meta.env.MONERIS_ORIGIN ||
    import.meta.env.VITE_MONERIS_ORIGIN ||
    'https://esqa.moneris.com',

  // Backend API
  paymentApiUrl:
    runtimeConfig.paymentApiUrl || import.meta.env.PAYMENT_API_URL || '',
  subscriptionKey:
    runtimeConfig.subscriptionKey || import.meta.env.SUBSCRIPTION_KEY || '',
});

export default environment;
